import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as Api from 'api';
import { Accordion, Panel, Row, Col, Button, ButtonGroup, Alert } from 'react-bootstrap';
import moment from 'moment';

const Header = props => {
  let icon;
  switch(props.type) {
    case 'GENERAL_ANNOUNCEMENT':
    case 'CLIENTS_IMPACTED':
    default:
      icon = "fa fa-bell";
  }

  return <div>
    <h5 className={props.className} onClick={props.onClick}><i className={icon} /> {props.title}</h5>
    <p className="panel-subtitle">Sent on {moment(props.created_timestamp).format('MMM DD, YYYY hh:mm:ss')}</p>
  </div>
}

class NotificationList extends Component {
  constructor(props) {
    super(props);
    this.refresh = this.refresh.bind(this);
    this.handleDelete = this.handleDelete.bind(this);

    this.state = { selectedItem: '', results: [] };

    this.refresh();
  }
  refresh() {
    this.setState({ loading: true });
    return Api.fetchNotifications({
      size: 10,
      offset: 0
    })
      .then(data => this.setState({ ...data, loading: false }))
      .catch(error => this.setState({ error, loading: false }));
  }
  handleDelete(id) {
    this.setState({ deleting: true });
    Api.deleteNotification(id)
      .then(response => this.refresh().then(e => this.setState({ deleting: false })))
      .catch(error => this.setState({ error, deleting: false }));
  }
  render() {

    return (
      <Row>
        <Col xs={12}>
          <h3>Sent Notifications</h3>
          {this.state.error ? (
            <Alert bsStyle='danger' onDismiss={e => this.setState({ error: null })}>
              {this.state.error.message}
            </Alert>
          ) : (null)}
          {this.state.loading ? (
            <p className="text-center"><i className='fa fa-spinner fa-spin' /></p>
          ) : !this.state.results || this.state.results.length == 0 ? (
            <Alert bsStyle='info'>
              <p className='text-center'>No recently sent notifications.</p>              
            </Alert>
          ) : null}
          <Accordion activeKey={this.state.selectedItem}>
            {(this.state.results || []).map(notification => (
              <Panel
                bsSize={'sm'}
                bsStyle={'success'}
                header={<Header {...notification} onClick={e => this.setState({ selectedItem: notification._id, confirmDeleteNotification: null })} />}
                eventKey={notification._id}
                key={notification._id}
                footer={this.state.selectedItem == notification._id ? <div className="clearfix">
                  {this.state.deleting? (
                    <p className="text-center"><i className="fa fa-spinner fa-spin" /> Deleting...</p>
                  ) : this.state.confirmDeleteNotification ? (
                    <div className='animated fadeInDown'>
                      <ButtonGroup className="pull-right">
                        <Button onClick={e => this.setState({ confirmDeleteNotification: null })}>No</Button>
                        <Button onClick={e => this.handleDelete(notification._id)} bsStyle={'danger'}>Yes</Button>
                      </ButtonGroup>

                      <p>Are you sure?</p>
                      <p>This action cannot be undone.</p>
                    </div>
                  ) : (
                    <Button
                      onClick={e => this.setState({ confirmDeleteNotification: notification._id })}
                      className='pull-right'
                      bsStyle={'danger'}>
                      <i className='fa fa-trash' />
                    </Button>
                  )}
                </div> : null}
                >
                {notification.message}
              </Panel>
            ))}
          </Accordion>
        </Col>
      </Row>
    );
  }
}

export default NotificationList;



// WEBPACK FOOTER //
// ./src/browser/components/notifications/notification-list.js